// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"menus-module--dropdown--1bp3y","dropbtn":"menus-module--dropbtn--3AtUR","dropdownContent":"menus-module--dropdown-content--1gdDu"};